import {AxiosReadPayload} from '../../shared/service/axios-read-payload';
import {axiosReadHelper} from '../../shared/service/axios-read-helper';
import {axiosSaveHelper} from '../../shared/service/axios-save-helper';
import {AxiosSavePayload} from '../../shared/service/axios-save-payload';

class MetaDataService{
  async getPatientEncounterMetaData(){
    const readPayload: AxiosReadPayload = {
      url: `patient-encounter/v2/patient/encounter/metaData`,
    };
    return await axiosReadHelper(readPayload);
  }
  async getPatientMetadata(){
    const readPayload: AxiosReadPayload = {
      url: `patient/v2/metadata`,
    };
    return await axiosReadHelper(readPayload);
  }

  async getPaymentMetadata(sources: string[] | undefined){

    let url = `payment/v2/payment/metadata`

    if(Array.isArray(sources) && sources.length > 0){
      url += `?sources=${sources.join(",")}`
    }
    const readPayload: AxiosReadPayload = {
      url,
    };
    return await axiosReadHelper(readPayload);
  }

  async getPaymentChannels(){
    const readPayload: AxiosReadPayload = {
      url: `payment/v2/payment/paymentchannels`,
    };
    return await axiosReadHelper(readPayload);
  }

  async getPaymentsV3Metadata(){
    const readPayload: AxiosReadPayload = {
      url: `payments/v3/metadata`,
    };
    return await axiosReadHelper(readPayload);
  }

  async getCRMMetaData() {
    const readPayload: AxiosReadPayload = {
      url: `clients/v2/client/metadata`,
      dataId:-2
    }
    return await axiosReadHelper(readPayload)
  }

  async getAlerts(clientId: string | number) {
    const readPayload: AxiosReadPayload = {
      url: `clients/v2/client/${clientId}/alert`,
      dataId:-2
    }
    return await axiosReadHelper(readPayload)
  }

  async getEmployers(clientId: string | number) {
    const readPayload: AxiosReadPayload = {
      url: `clients/v2/client/${clientId}/employer`,
      dataId:-2
    }
    return await axiosReadHelper(readPayload)
  }

  async createEmployer({clientId, employerName}: {clientId: number, employerName: string}) {
    const readPayload: AxiosSavePayload = {
      url: `clients/v2/client/${clientId}/employer`,
      dataToSave: {
        employerName
      },
      dataId:0
    }
    return await axiosSaveHelper(readPayload)
  }

}

export const metaDataService = new MetaDataService();